module.exports = __webpack_public_path__ + "static/background_768-baf15b033d953bc64ed02dc90934cd92.png";